import { REQUEST_STATUSES } from "@/constants/index.js";
import { getNewList } from "@/utils/helper.js";

import * as types from "./types.js";

const initialState = {
  users: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
  noResults: false,
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_USERS: {
      const { users, status, err, query } = action.payload;
      const newUsers = getNewList(query, state.users, users);
      return {
        ...state,
        users: newUsers,
        status,
        err,
        noResults: !newUsers.length,
      };
    }
    case types.SET_USERS_REQUEST_STATUS:
      return { ...state, ...action.payload };
    case types.RESET_USERS:
      return { ...initialState };
    default:
      return state;
  }
};
